// ** Redux Imports
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
// ** Axios Imports
import axios from 'axios'

export const setLoading = createAsyncThunk('customerRecurrenceInvoice/setLoading', async (loadingState) => ({ ...loadingState }))

export const getData = createAsyncThunk('customerRecurrenceInvoice/getData', async (params, { dispatch }) => {
  dispatch(setLoading({ getData: true }))
  const response = await axios.get('/SalesInvoices/RecurringInvoicesList', { params })
  dispatch(setLoading({ getData: false }))
  return {
    params,
    data: response.data,
  }
})

export const customerRecurrenceInvoiceSlice = createSlice({
  name: 'customerRecurrenceInvoice',
  initialState: {
    vendorInvoice: {},
    data: [],
    // consolidated: [],
    totalRecords: 1,
    // consolidatedTotalRecords: 1,
    typeData: [],
    totalTypeRecords: 1,
    params: {},
    typeParams: {},
    loadingState: { getData: false }
    // allData: []
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getData.fulfilled, (state, action) => {
        state.data = action.payload.data.data.list
        // state.consolidated = action.payload.consolidated.data.list
        state.totalRecords = action.payload.data.totalRecords
        // state.consolidatedTotalRecords = action.payload.consolidated.totalRecords
        state.params = action.payload.params
      })
      .addCase(setLoading.fulfilled, (state, action) => {
        state.loadingState = action.payload
      })
  }
})

export default customerRecurrenceInvoiceSlice.reducer
